const red = '#FF6F00';
const orange = '#F57F17';
const orangeLight = '#F9A825';
const yellow = '#FBC02D';
const yellowLight = '#FDD835';
const green = '#C0CA33';
const greenLight = '#83C832';
const greenNeon = '#64DD17';
const harborBlue = '#003a5d';

export const stdColors = {
  red,
  orange,
  orangeLight,
  yellow,
  yellowLight,
  green,
  greenLight,
  greenNeon,

  harborBlue,
};

const RETIREMENT_SPENDING_POWER_TITLE = 'Retirement Spending Power';
const RETIREMENT_SPENDING_POWER_FORMAT = 'DOLLARS_PER_YEAR';
const SOCIAL_SECURITY_LIFETIME_VALUE_TITLE = 'Lifetime Value of Social Security';
const SOCIAL_SECURITY_LIFETIME_VALUE_FORMAT = 'DOLLARS';
const MONEY_LASTS_UNTIL_TITLE = 'Money Should Last Until';
const MONEY_LASTS_UNTIL_FORMAT = 'AGE';

export const scoreCardCopy = {
  RETIREMENT_SPENDING_POWER_TITLE,
  RETIREMENT_SPENDING_POWER_FORMAT,
  SOCIAL_SECURITY_LIFETIME_VALUE_TITLE,
  SOCIAL_SECURITY_LIFETIME_VALUE_FORMAT,
  MONEY_LASTS_UNTIL_TITLE,
  MONEY_LASTS_UNTIL_FORMAT,
};
